import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackChooseLoginMethod = ({ method: login_method }) => {
  ga.track('choose_login_method', { login_method })
  // The schema has no dedicated "choose login method" event,
  // so this stays on user_start_login but is marked with interaction_type
  // 'method_selection' (vs 'cta' on trackStartLogin) so the two are countable
  // separately. authentication_method carries which method was chosen.
  amplitude.track('user_start_login', {
    ...baseWebEventProps(),
    action_name: 'start',
    action_type: 'active',
    interaction_type: 'method_selection',
    authentication_method: login_method,
  })
}
